'use client'

import type { PropsWithChildren } from 'react'

import { SCREEN_ADDRESS_ROUTE } from '@repo/address-screening/client'
import { Web3Provider as WagmiWeb3Provider } from '@repo/web3'

import { wagmiAdapter, wagmiConfig } from '@/lib/modules/web3/web3.config.client'

export function Web3Provider({ children, cookies }: PropsWithChildren<{ cookies: string | null }>) {
  return (
    <WagmiWeb3Provider
      wagmiAdapter={wagmiAdapter}
      wagmiConfig={wagmiConfig}
      cookies={cookies}
      screenAddressEndpoint={SCREEN_ADDRESS_ROUTE}
    >
      {children}
    </WagmiWeb3Provider>
  )
}
